export default "__VITE_ASSET__$MEL4$mU__"